export default ($httpProvider) => {
    const apiUrl = SEED_CORE.ENV.API_URL;
    const wpUrl = SEED_CORE.ENV.WP_URL;
    const excludedSentryHttpCodes = [-1, 403, 404, 500];

    const sendToSentry = (response, $injector) => {
        const Raven = $injector.get('Raven');
        const url = response.config.url;
        const msg = `${response.statusText || 'HTTP response error'} - ${url}`;
        Raven.captureMessage(msg, {
            extra: {
                config: response.config,
                response: response.data,
                status: response.status
            },
            fingerprint: ['{{ default }}', url]
        });
    };

    $httpProvider.interceptors.push(($location, $injector, $q, $rootScope) => ({
        response (response) {
            const token = (response.headers('x-authorization') || '').replace('Bearer ', '');
            if (token) {
                const TokenService = $injector.get('TokenService');
                TokenService.token = token;
            }
            return response;
        },
        responseError (response) {
            const status = response.status;
            if (status !== 422) {
                const $translate = $injector.get('$translate');
                const toastr = $injector.get('toastr');
                if (status === 401) {
                    const AuthService = $injector.get('AuthService');

                    AuthService.logout();
                    $rootScope.$emit('authentication:required');
                    // $state.transitionTo('auth.authorize');
                    const message = $translate.instant('Your session has expired. Please log in again.');
                    toastr.error(message);
                    if (!response.data.message) {
                        response.data.message = message;
                    }
                }
                else if (status === 400) {
                    if (!response.data.code || response.data.code !== 9999) {
                        sendToSentry(response, $injector);
                    }
                    toastr.error(response.data.message);
                }
                else if (status === 403) {
                    toastr.error(response.data.message);
                }
                else {
                    const lodash = $injector.get('lodash');
                    // make sure we want to send data to Sentry
                    if (!lodash.includes(excludedSentryHttpCodes, status)) {
                        sendToSentry(response, $injector);
                    }
                    toastr.error(response.statusText || $translate.instant('general.Something went wrong'));
                }
            }
            return $q.reject(response);
        },
        request (request) {
            // detect from url (e.g in quiz)
            const lang = $location.search().lang;
            const TokenService = $injector.get('TokenService');
            const token = TokenService.token;
            const lodash = $injector.get('lodash');
            const isApiUrl = request.url.indexOf(apiUrl) === 0;

            // Only add the Bearer to requests aimed specifically at our yii or wp domain
            // we use indexOf instead of startsWith for IE11 support
            if (isApiUrl || request.url.indexOf(wpUrl) === 0) {
                // we add no-cache header for Yii requests because IE thinks its okay to cache ajax requests
                if (isApiUrl) {
                    request.headers.Pragma = 'no-cache';
                }

                if (token) {
                    // we add 'Bearer ' in front of token for requests aimed at yii domain
                    request.headers['X-Authorization'] = request.url.indexOf(apiUrl) === 0 ? `Bearer ${token}` : token;
                }
            }

            // send active language via language header
            if (lang) {
                request.headers['Accept-Language'] = lang;
            }
            else if ($rootScope.language) {
                request.headers['Accept-Language'] = $rootScope.language;
            }
            else if (token) {
                request.headers['Accept-Language'] = TokenService.getActiveLanguage();
            }
            else if ($rootScope.company) {
                // unauthorized states where company is resolved on state level and passed to rootScope
                request.headers['Accept-Language'] = $rootScope.company.defaultLanguage;
            }

            if (isApiUrl && request.method === 'GET' && !lodash.has(request, 'params.pageSize')) {
                if (!lodash.has(request, 'params') || typeof request.params === 'string') {
                    request.params = {};
                }
                request.params.pageSize = 0;
            }

            return request;
        }
    }));
};



// WEBPACK FOOTER //
// ./src/app/configs/http/index.js